export enum DeliveryType {
  INVITATION_DELIVERY = 'Invitation',
  INVOICE_DELIVERY = 'Invoice',
  EVENT_DELIVERY = 'Event',
  BOOKING_DELIVERY = 'Booking',
}
